export default __webpack_public_path__ + "3596c8352161ef5d7099b2acd70168f5.png";